import { SetStateAction, useCallback, useContext } from "react";
import { StoredPaymentCardHookType } from "./payment-card-context.types";
import { IndexerValueTypes } from "../../interfaces/IndexerValueTypes";
import { PaymentCardsContext } from "./payment-card-context";
import { StoredPaymentCard } from "../../interfaces/StoredPaymentCards";

export const usePaymentCard = (): StoredPaymentCardHookType => {
  const { paymentCards, setPaymentCards } = useContext(PaymentCardsContext);

  const createPaymentCards = useCallback(
    (newcreatePaymentCard: StoredPaymentCard[]): void => {
      setPaymentCards(newcreatePaymentCard);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [paymentCards]
  );

  const onChangePaymentCards = useCallback(
    (newValue: IndexerValueTypes): void => {
      setPaymentCards({
        ...paymentCards,
        newValue,
      } as SetStateAction<StoredPaymentCard[] | undefined>);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [paymentCards]
  );

  const deletePaymentCards = useCallback((): void => {
    setPaymentCards(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentCards]);

  return {
    paymentCards,
    createPaymentCards,
    onChangePaymentCards,
    deletePaymentCards,
  };
};
